import getOr from "lodash/fp/getOr";
import { nFormatter } from "../utils/utils";
import { Requirement } from "./requirement";
import { TariffDetail } from "./tariffDetail";
import { TariffsRevamp } from "./TariffsRevamp";
import { RegulationTariff } from "./regulationTariff";

export class Tariffs {
  constructor(total, totalText, totalTextRaw, unit, tariffs, fees, requirements, importTariffs, exportTariffs, regulations) {
    this.total = total;
    this.totalText = totalText;
    this.totalTextRaw = totalTextRaw;
    this.unit = unit;
    this.tariffs = tariffs;
    this.fees = fees;
    this.requirements = requirements;
    /** @type {[TariffsRevamp]} */
    this.importTariffs = importTariffs;
    /** @type {[TariffsRevamp]} */
    this.exportTariffs = exportTariffs;
    /** @type {[RegulationTariff]} */
    this.regulations = regulations;
  }
  static fromApiObject(input, currency) {
    if (typeof (input) === "object" && input !== null) {
      let total = {
        from: getOr(0, "amount.from")(input),
        to: getOr(undefined, "amount.to")(input),
      }
      const currencyReal = getOr(currency, "amount.currency")(input);
      const unit = getOr(currency, "unit")(input);
      const tariffs = TariffDetail.fromApiArray(getOr([], "tariffs")(input), currency);
      const fees = TariffDetail.fromApiArray(getOr([], "fees")(input), currency);
      const totalText = `<span class="currency">${currencyReal}</span> ${nFormatter(total.from, 2)}${total.to !== undefined && total.to !== total.from && total.to * 1 > 0 ? " - " + nFormatter(total.to, 2) : ""}`;
      const totalTextRaw = `${currencyReal} ${total.from}${total.to !== undefined && total.to !== total.from && total.to * 1 > 0 ? " - " + total.to : ""}`;
      const importTariffs = TariffsRevamp.fromApiArray(getOr([], "import")(input));
      const exportTariffs = TariffsRevamp.fromApiArray(getOr([], "export")(input));
      const regulations = RegulationTariff.fromApiArray(getOr([], "regulation")(input));
      
      return new Tariffs(total, totalText, totalTextRaw, unit || currencyReal, tariffs, fees, Requirement.fromApiArray(input.regulations), importTariffs, exportTariffs, regulations);
      // return new Tariffs(total, totalText, totalTextRaw, unit || currencyReal, tariffs, fees, Requirement.fromApiArray([
      //   {
      //     name: "restricted", 
      //     label: "Restricted use of certain substances",
      //     hint: "Certain substances",
      //     checked: true
      //   },
      //   {
      //     name: "production", 
      //     label: "Production or Post-Production requirements",
      //     hint: "",
      //     checked: false
      //   },
      //   {
      //     name: "food", 
      //     label: "Food and feed processing",
      //     hint: "",
      //     checked: true
      //   }
      // ]));
    }
    return new Tariffs();
  }
  static fromApiArray(input, currency) {
    if (Array.isArray(input)) {
      return input.map(item => Tariffs.fromApiObject(item, currency));
    }
    if (typeof (input) === "object" && input !== null) {
      return [Tariffs.fromApiObject(input, currency)];
    }
    return [];
  }

  genRequirement() {
    let result = "";
    this.requirements.forEach((element, index) => {
      result += element.genHtml();
    });
    return result;
  }

  genDetailHtml() {
    let translate = window.searchData.destination === "NO" ? ' class="translate"' : "";

    let result = "";
    this.tariffs.forEach(element => {
      let hint = '';
      if (element.hint && element.hint !== element.label) {
        hint = `<div class="instruction">
          <div class="dropdown">
            <div class="content">
              ${element.hint}
            </div>
          </div>
        </div>`;
      }
      const value =  element.highlight ? element.valueText : element.valueText.replace(element.highlight, `<b style="background: #FFFE54;">${element.highlight}</b>`);
      result += `<tr class="item${element.isNotApply ? " not-apply" : ""}">
        <td${translate}>${element.agreementName}${hint}</td$>
        <td${translate} title="${element.valueTextRaw}">${value}</td$>
        <td title="${element.isNotApply ? "Not Applicable" : element.totalTextRaw}">${element.isNotApply ? "Not Applicable" : element.totalText}</td>
      </tr>`
    });
    this.fees.forEach(element => {
      let hint = '';
      if (element.hint && element.hint !== element.label) {
        hint = `<div class="instruction">
          <div class="dropdown">
            <div class="content">
              ${element.hint}
            </div>
          </div>
        </div>`;
      }
      const value =  element.highlight ? element.valueText : element.valueText.replace(element.highlight, `<b style="background: #FFFE54;">${element.highlight}</b>`);
      result += `<tr class="item${element.isNotApply ? " not-apply" : ""}">
        <td${translate}>${element.agreementName}${hint}</td$>
        <td${translate} title="${element.valueTextRaw}">${value}</td$>
        <td title="${element.isNotApply ? "Not Applicable" : element.totalTextRaw}">${element.isNotApply ? "Not Applicable" : element.totalText}</td>
      </tr>`
    });
    return result;
  }
}